import font from "./Roboto-Regular.ttf";

export const fontData = font;